import { Badge, Switch, Table } from 'antd';
import React, { useEffect, useState } from 'react';

import api from '~/services/api';

import { Container, StyledTableWrapper } from './styles';

export default function Store() {
  const [stores, setStores] = useState([]);
  const [showInactive, setShowInactive] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function fetchStores() {
      setLoading(true);
      try {
        const response = await api.get(`stores${showInactive ? '?showAll=true' : ''}`);
        setStores(response.data);
      } catch (err) {
        // handle error, e.g. show notification
      } finally {
        setLoading(false);
      }
    }
    fetchStores();
  }, [showInactive]);

  // No need to filter client-side, API returns correct list
  const filteredStores = stores;

  const columns = [
    {
      title: '',
      dataIndex: 'active',
      key: 'active',
      align: 'center',
      render: (active) => <Badge color={active ? '#52c41a' : '#bfbfbf'} style={{ verticalAlign: 'middle' }} />,
      width: 32,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (name) => <span style={{ fontWeight: 500 }}>{name}</span>,
      width: 180,
    },
    {
      title: 'Shipstation Store ID',
      dataIndex: 'shipstation_store_id',
      key: 'shipstation_store_id',
      align: 'center',
      width: 120,
    },
    {
      title: 'Status',
      dataIndex: 'active',
      key: 'statusText',
      align: 'center',
      render: (active) => <span style={{ color: active ? '#52c41a' : '#bfbfbf', fontWeight: 500 }}>{active ? 'Active' : 'Inactive'}</span>,
      width: 80,
    },
  ];

  return (
    <Container>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24, justifyContent: 'space-between' }}>
        <h1 style={{ margin: 0 }}>Stores</h1>
        <div>
          <span style={{ marginRight: 8 }}>Show Inactive</span>
          <Switch checked={showInactive} onChange={setShowInactive} />
        </div>
      </div>
      <StyledTableWrapper>
        <Table
          columns={columns}
          dataSource={filteredStores}
          rowKey="id"
          loading={loading}
          pagination={false}
          size="small"
          rowClassName={(row) => (!row.active ? 'inactive-row' : '')}
        />
      </StyledTableWrapper>
    </Container>
  );
}
